var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('PageLoader'),_c('v-app',{attrs:{"id":"app"}},[(
        _vm.$vuetify.breakpoint.name == 'xs'
      )?_c('AppHeader'):_vm._e(),(
        _vm.$vuetify.breakpoint.name !== 'xs' )?_c('mainHeader'):_vm._e(),_c('div',{style:({
        'padding-top': _vm.$vuetify.breakpoint.name == 'xs' ? '49px' : '99px',
      })},[_c('router-view',{key:_vm.$route.fullPath})],1),_c('AppFooter')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }